


























































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getImplement, UnitProjectImplementData, emptyImplement } from '@/api/heritageUnit/unitProject'
import Element from 'element-ui'
import singleFile from '@/components/upload/singleFile.vue'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: { ViewDialog, singleFile }
})
export default class UnitProjectImplementView extends Vue {
  public name = 'UnitProjectImplementView'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  public showDialog: boolean = false
  public expandNames: string[] = ['proposal', 'project', 'proposalFund', 'projectFund']
  public loading: boolean = false
  public form: UnitProjectImplementData = Object.assign({}, emptyImplement)
  public $refs!: {
    formData: Element.Form
  }
  get proposalDate(): string {
    const f = this.form
    var data = ''
    if (f.ProposalBeginYear > 0 && f.ProposalBeginMonth > 0) {
      data = f.ProposalBeginYear.toString() + '年' + f.ProposalBeginMonth.toString() + '月'
    }
    return data
  }
  get projectStartDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectStartYear > 0 && f.ProjectStartMonth > 0) {
      data = f.ProjectStartYear.toString() + '年' + f.ProjectStartMonth.toString() + '月'
    }
    return data
  }
  get projectEndDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectEndYear > 0 && f.ProjectEndMonth > 0) {
      data = f.ProjectEndYear.toString() + '年' + f.ProjectEndMonth.toString() + '月'
    }
    return data
  }
  get checkDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectCheckYear > 0 && f.ProjectCheckMonth > 0) {
      data = f.ProjectCheckYear.toString() + '年' + f.ProjectCheckMonth.toString() + '月'
    }
    return data
  }
  get acceptanceDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectAcceptanceYear > 0 && f.ProjectAcceptanceMonth > 0) {
      data = f.ProjectAcceptanceYear.toString() + '年' + f.ProjectAcceptanceMonth.toString() + '月'
    }
    return data
  }
  public created() {
  }
  public mounted() {
    window.eventBus.$on("viewUnitProjectImplement", (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewUnitProjectImplement')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    getImplement(id).then((response: { data: any }) => {
      this.form = response.data
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
}
